import { render, staticRenderFns } from "./CtintContactHistoryListDetail.vue?vue&type=template&id=9b5cc280&"
import script from "./CtintContactHistoryListDetail.vue?vue&type=script&lang=js&"
export * from "./CtintContactHistoryListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports